"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsConstructorExperience = exports.getRandomKeyByWeight = exports.buildConstructorSlugifyDictionary = exports.sharedFacetNameList = void 0;
// Create a LIST of Shared Facets ** Slugifid Version **
// We use this to make sure we dont create a URL path of `/abstract/abstract`
// We will allow a second parameter for letting us know the order of importance
// We want to know what FacetName should take precedence
// facets: { styles: {'abstract': ...}, subject: {'abstract': ...}, }
// Result => { abstract: ['style', 'subject'] } OR { attibuteName: { facetName, facetName }}
const sharedFacetNameList = (dictionary, pathParams) => {
    const pathKeys = pathParams || Object.keys(dictionary);
    const list = pathKeys.reduce((results, facetName) => {
        const dictionaryValues = dictionary[facetName];
        // Make sure the FacetName Exist - Algolia Indices differ based on ENV
        if (dictionaryValues) {
            // Build out List of Items { abstract: [ 'styles', 'subject' ], paper: [ 'mediums' ], ...}
            Object.keys(dictionaryValues).forEach((attributeName) => {
                if (results[attributeName]) {
                    // If Key VALUE exist, merge values together
                    results[attributeName] = [...results[attributeName], facetName];
                }
                else {
                    results[attributeName] = [facetName];
                }
            });
        }
        return results;
    }, {});
    // Filter List Down to items containing 2 Items
    return Object.entries(list).reduce((filteredList, [attibuteName, facetNames]) => (Object.assign(Object.assign({}, filteredList), (Array.isArray(facetNames) && facetNames.length !== 1
        ? {
            [attibuteName]: facetNames,
        }
        : null))), {});
};
exports.sharedFacetNameList = sharedFacetNameList;
// slugify('This WorKing') => 'this-working'
const slugify = (str) => String(str || '')
    .replace(/[^a-z0-9]/gi, '-')
    .toLowerCase()
    .replace(/-{2,}/g, '-') // Remove Multiple '-': 'this-is---a-link' => 'this-is-a-link'
    .replace(/^-/, '') // Remove Starting `-`
    .replace(/-$/, '');
// Expects a object => { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... }
// Will return a new Object => { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... }
const buildSlugifyObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [slugify(key)]: key === null || key === void 0 ? void 0 : key.toLowerCase() })), {});
const buildObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [key]: key === null || key === void 0 ? void 0 : key.toLowerCase() })), {});
// Expects a object => { facets: { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... } }
// Will return a new Object => { facets: { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... } }
const buildConstructorSlugifyDictionary = (obj) => Object.entries(obj).reduce((results, [key, value]) => key.search(/curated_status/) > -1 // Skip these values - do NOT slugify
    ? Object.assign(Object.assign({}, results), { [key]: buildObject(value) }) : Object.assign(Object.assign({}, results), { [key]: buildSlugifyObject(value) }), {});
exports.buildConstructorSlugifyDictionary = buildConstructorSlugifyDictionary;
const getRandomKeyByWeight = (weights) => {
    const entries = Object.entries(weights);
    const totalWeight = entries.reduce((sum, [, weight]) => sum + weight, 0);
    if (totalWeight <= 0) {
        return null; // no valid weights
    }
    let threshold = Math.random() * totalWeight;
    for (const [key, weight] of entries) {
        threshold -= weight;
        if (threshold <= 0) {
            return key;
        }
    }
    return null; // fallback (shouldn't happen)
};
exports.getRandomKeyByWeight = getRandomKeyByWeight;
const getIsConstructorExperience = (abTestObject) => {
    const constructorAABBTest = abTestObject === null || abTestObject === void 0 ? void 0 : abTestObject[48];
    const isConstructorABTestMissing = typeof constructorAABBTest === 'undefined';
    if (isConstructorABTestMissing) {
        const randomWeightObject = {
            ['isConstructor']: 50,
            ['isNotConstructor']: 50,
        };
        const randomABTestKey = (0, exports.getRandomKeyByWeight)(randomWeightObject);
        return randomABTestKey === 'isConstructor';
    }
    const isConstructorAbTestValue = constructorAABBTest === '03' || constructorAABBTest === '04';
    return isConstructorAbTestValue;
};
exports.getIsConstructorExperience = getIsConstructorExperience;
